import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['data', 'options'],
  mounted () {
    this.renderChart(this.data, this.options)
  },
}



// WEBPACK FOOTER //
// ./src/components/charts/LineChart.js